// Common paths
export const Paths = () => {
  return {
    root: () => '/'
  };
};

export default Paths;
